module.exports = __webpack_public_path__ + "img/car_shina2_18.78e87291.jpg";